import { render, staticRenderFns } from "./Page-Registers.vue?vue&type=template&id=3aa502c6&scoped=true"
import script from "./Page-Registers.vue?vue&type=script&lang=js"
export * from "./Page-Registers.vue?vue&type=script&lang=js"
import style0 from "./Page-Registers.vue?vue&type=style&index=0&id=3aa502c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa502c6",
  null
  
)

export default component.exports